// extracted by mini-css-extract-plugin
export default {"title":"PetsFamily-module__title--lNs4q","familyBrands":"PetsFamily-module__familyBrands--ggEJL"};